// Placeholder card for unknown / TODO visual types.

import type { VisualProps } from "./types";
import "./_static.css";

export function PlaceholderVisual({ spec }: VisualProps) {
  return (
    <div className="static-placeholder">
      <div className="static-placeholder-type">{spec.type}</div>
      {spec.title && <div className="static-placeholder-title">{spec.title}</div>}
      <span className="static-placeholder-todo">TODO</span>
    </div>
  );
}
